import { useState } from "react";

const NOTE_STATUS_STYLE = {
    planned: "bg-blue-100 text-blue-700",
    ongoing: "bg-amber-100 text-amber-700",
};

const NOTE_STATUS_LABEL = {
    planned: "Planerad",
    ongoing: "Pågående",
};

/* Start-tork form: employee enters dryStarted plus EITHER a duration (hours)
   OR a fixed finish timestamp. */
const StartTorkModal = ({ order, torkNotes = [], noteTypes = [], onSubmit, onClose }) => {
    const now = new Date();
    const nowLocal = new Date(now.getTime() - now.getTimezoneOffset() * 60000).toISOString().slice(0, 16);
    const [dryStarted, setDryStarted] = useState(nowLocal);
    const [mode, setMode] = useState("finish"); // duration | finish
    const [durationHours, setDurationHours] = useState(13);
    const [dryFinished, setDryFinished] = useState("");
    const handleSubmit = (e) => {
        e.preventDefault();
        const payload = {
            dryStarted: dryStarted ? new Date(dryStarted).toISOString() : null,
        };
        if (mode === "duration") {
            payload.durationHours = Number(durationHours);
        } else {
            if (!dryFinished) return;
            payload.dryFinished = new Date(dryFinished).toISOString();
        }
        onSubmit(order.id, payload);
    };

    const activeNotes = torkNotes.filter(n => n.status === "planned" || n.status === "ongoing");

    return (
        <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50 p-4" onClick={onClose}>
            <form onSubmit={handleSubmit}
                className="bg-white rounded-lg shadow-xl w-full max-w-md p-6" onClick={e => e.stopPropagation()}>
                <h2 className="text-xl font-semibold mb-1">Starta tork</h2>
                <p className="text-sm text-gray-500 mb-4">
                    Order {order.orderId} · {order.type}
                </p>

                {activeNotes.length > 0 && (
                    <div className="mb-4 rounded-lg border border-amber-300 bg-amber-50 p-3">
                        <p className="text-xs font-semibold text-amber-700 uppercase tracking-wide mb-2">
                            Noteringar på torken
                        </p>
                        <ul className="space-y-1.5">
                            {activeNotes.map(n => {
                                const color = noteTypes.find(nt => nt.name === n.type)?.color || "#9CA3AF";
                                return (
                                    <li key={n.id} className="flex items-start gap-2 text-sm">
                                        <span className="inline-block w-2.5 h-2.5 rounded-full flex-shrink-0 mt-1" style={{ backgroundColor: color }} />
                                        <span className="font-medium text-gray-800 shrink-0">{n.type}</span>
                                        {n.note && <span className="text-gray-600">{n.note}</span>}
                                        <span className={"ml-auto shrink-0 text-xs rounded px-1.5 py-0.5 " + (NOTE_STATUS_STYLE[n.status] || "bg-gray-100 text-gray-700")}>
                                            {NOTE_STATUS_LABEL[n.status] || n.status}
                                        </span>
                                    </li>
                                );
                            })}
                        </ul>
                    </div>
                )}

                <label className="block text-sm font-medium text-gray-700 mb-1">Torkning startad</label>
                <input type="datetime-local" className="input mb-4" value={dryStarted}
                    onChange={e => setDryStarted(e.target.value)} required />

                <div className="flex gap-4 mb-3">
                    <label className="flex items-center gap-2 text-sm">
                        <input type="radio" checked={mode === "finish"}
                            onChange={() => setMode("finish")} />
                        Fast sluttid
                    </label>
                    <label className="flex items-center gap-2 text-sm">
                        <input type="radio" checked={mode === "duration"}
                            onChange={() => setMode("duration")} />
                        Torktid (timmar)
                    </label>
                </div>

                {mode === "duration" ? (
                    <input type="number" min="0" step="0.5" className="input mb-4"
                        value={durationHours} onChange={e => setDurationHours(e.target.value)}
                        placeholder="Antal timmar" required />
                ) : (
                    <input type="datetime-local" className="input mb-4"
                        value={dryFinished} onChange={e => setDryFinished(e.target.value)} required />
                )}

                <div className="flex justify-end gap-2">
                    <button type="button" onClick={onClose}
                        className="px-4 py-2 rounded-lg border border-gray-300 hover:bg-gray-100">
                        Avbryt
                    </button>
                    <button type="submit"
                        className="px-4 py-2 rounded-lg bg-green-600 text-white hover:bg-green-700">
                        Starta
                    </button>
                </div>
            </form>
        </div>
    );
};

export default StartTorkModal;
